import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { OrganizationKeyName } from "../model/Organization";
import { VenuesInsertSuccessResponse } from "./api-response/VenuesInsertSuccessResponse";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { VenuesSuccessResponse } from "./api-response/VenuesSuccessResponse";
import { VenueGetSuccessResponse } from "./api-response/VenueGetSuccessResponse";
import { Venue } from "../model/Venue";
import { map } from "rxjs/operators";

export class ApiVenue {
  constructor(private apiEndpoint: string) {}

  listAll(
    token: string,
    organization: OrganizationKeyName
  ): Observable<VenuesSuccessResponse> {
    return ajax({
      url: `${this.apiEndpoint}/organizations/${organization}/venues`,
      method: "GET",
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x) => x.response));
  }

  get(
    token: string,
    organization: OrganizationKeyName,
    id: number | string
  ): Observable<VenueGetSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/venues/${id}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  update(
    token: string,
    organization: OrganizationKeyName,
    id: number | string,
    data: Partial<Venue>
  ): Observable<null> {
    return ajax({
      method: "PUT",
      url: `${this.apiEndpoint}/organizations/${organization}/venues/${id}`,
      body: {
        ...data,
        id,
      },
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  insert(
    token: string,
    organization: OrganizationKeyName,
    data: Partial<Venue>
  ): Observable<number> {
    return ajax({
      method: "POST",
      url: `${this.apiEndpoint}/organizations/${organization}/venues`,
      body: data,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(
      map((x: any) => x.response),
      map((x: VenuesInsertSuccessResponse) => x.data.venueId)
    );
  }
}
